import baseMixin from './baseMixin'
import { styler, tween, timeline } from 'popmotion'

export default {
    mixins: [baseMixin],

    beforeCreate() {
        this.baseElementQueryString = 'align-strategy-graphic'
    },

    methods: {
        setStyler() {
            this.arrows = {
                lead: this.q('#lead-arrow'),
                arrow1: this.q('#arrow-1'),
                arrow2: this.q('#arrow-2'),
                arrow3: this.q('#arrow-3'),
                arrow4: this.q('#arrow-4')
            }
        },

        initAction() {
            return tween({ from: 1, to: 0 })
        },

        animationAction() {
            return timeline([
                {
                    track: 'lead',
                    from: { x: -50, opacity: 1 },
                    to: { x: 0, opacity: 1 },
                    duration: 500
                },
                250,
                [
                    {
                        track: 'arrow1',
                        from: { x: -20, rotate: -30, opacity: 0 },
                        to: { x: 0, rotate: 0, opacity: 1 },
                        duration: 1500
                    },
                    {
                        track: 'arrow2',
                        from: { x: -25, rotate: -20, opacity: 0 },
                        to: { x: 0, rotate: 0, opacity: 1 },
                        duration: 1500
                    },
                    {
                        track: 'arrow3',
                        from: { x: -30, rotate: 20, opacity: 0 },
                        to: { x: 0, rotate: 0, opacity: 1 },
                        duration: 1500
                    },
                    {
                        track: 'arrow4',
                        from: { x: -35, rotate: 30, opacity: 0 },
                        to: { x: 0, rotate: 0, opacity: 1 },
                        duration: 1500
                    }
                ]
            ])
        },
        initReaction(v) {
            Object.keys(this.arrows).map(a => {
                this.arrows[a].set({ opacity: v })
            })
        },

        animationReaction(values) {
            for (let track in values) {
                this.arrows[track].set(values[track])
            }
        },

        q(s) {
            return styler(this.baseElement.querySelector(s))
        }
    }
}
